export const SPLIDE_TYPES = {
    SLIDER: 'slider',
    TABS: 'tabs'
};
export const isValidSplideType = (type)=>{
    return Object.values(SPLIDE_TYPES).includes(type);
};
